"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const cosmwasmcodec_1 = require("./cosmwasmcodec");
const cosmwasmconnection_1 = require("./cosmwasmconnection");
/**
 * A helper to connect to a cosmos-based chain at a given url
 */
function createCosmWasmConnector(url, addressPrefix, tokenConfig, expectedChainId) {
    const codec = new cosmwasmcodec_1.CosmWasmCodec(addressPrefix, tokenConfig.bankTokens, tokenConfig.erc20Tokens);
    return {
        establishConnection: async () => cosmwasmconnection_1.CosmWasmConnection.establish(url, addressPrefix, tokenConfig),
        codec: codec,
        expectedChainId: expectedChainId,
    };
}
exports.createCosmWasmConnector = createCosmWasmConnector;
//# sourceMappingURL=cosmwasmconnector.js.map